import React, { useEffect, useState } from "react";
import styles from "./MiPerfil.module.scss";
import { ReactComponent as PerfilBag } from "../../../assets/svg/perfil-bag.svg";
import UserInfo from "../../UI/UserInfo/UserInfo";
import { ReactComponent as PerfilEdit } from "../../../assets/svg/perfilEdit.svg";
import mail from "../../../assets/images/mail.png";
import { ReactComponent as FacebookIcon } from "../../../assets/svg/facebookSvg.svg";
import { ReactComponent as InstagramIcon } from "../../../assets/svg/instagramSvg.svg";
import { ReactComponent as LinkedinIcon } from "../../../assets/svg/linkedinSvg.svg";
import { ReactComponent as TwitterIcon } from "../../../assets/svg/twitterSvg.svg";
import Star from "../../../assets/images/star.png";
import { ReactComponent as WhatsAppIcon } from "../../../assets/svg/whatsAppIcon.svg";
import { ReactComponent as WebIcon } from "../../../assets/svg/webIcon.svg";
import Reputacion from "../Reputacion/Reputacion";
import { connect } from "react-redux";
import { openAction } from "../../../store/actions/authActions";
import ProfileEditModal from "../../UI/ProfileEditModal/ProfileEditModal";
import {
  openMainModal,
  testPersonaEdit,
  testEmpresaEdit,
  closeMainModal,
  generateVisit,
  openSuscriptionModal,
} from "../../../store/actions/profileActions";
import useGuestAccountCheck from "../../../hooks/useGuestAccountCheck";
import MiSuscripcion from "../PerfilMain/MiSuscripcion";

const MiPerfil = ({
  userData,
  closeMainModal,
  userId,
  openAction,
  profileVisualizer,
  profileType,
  openSuscriptionModal,
  generateVisit,
  previousLocation,
  handleGoBack,
  isUserPremium,
  isCancelledSuscriptionStillActive,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [planStatus, setPlanStatus] = useState("");
  const { type, phone, username, url_site_web, linkedin, instagram, facebook, twitter } = userId
    ? userId !== userData.id
      ? profileVisualizer
      : userData
    : userData;
  const guestAccountCheck = useGuestAccountCheck();
  //Datos de contacto
  const url = `https://wa.me/${phone}`;
  const fullUrl = url_site_web?.startsWith('http://') || url_site_web?.startsWith('https://')
    ? url_site_web
    : `https://${url_site_web}`;
  const formattedWebSite = url_site_web ? url_site_web?.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "").split('/')[0] : null;
  const webSiteUrl = url_site_web ? new URL(`https://${url_site_web}`) : null;

  const onMail = () => {
    window.open(`mailto:${username}?subject=Subject&body=Body%20goes%20here`);
  };
  const myPerson = !userId || userId === userData.id;

  const hasSocialNetworks = linkedin || instagram || facebook || twitter;

  //Genera la visita en el perfil
  useEffect(() => {
    if (!myPerson) {
      generateVisit(parseInt(userId));
    }
  }, []);

  useEffect(() => {
    if (userData.subscription !== null) {
        setPlanStatus(userData.subscription?.plan_name)
    } if (userData.freeTrial?.status !== "terminate") {
        setPlanStatus("Prueba Premium")
    } if (!isUserPremium) {
        setPlanStatus("Plan Básico")
    }
  }, []);

  const editHandler = () => {
    setIsEditing(!isEditing);
  }


  useEffect(() => {
    if (userId && userId !== userData.id) {
      openAction(userId);
    }
  }, [userId, userData, openAction]);

  return (
    <>
      {previousLocation?.includes("/comunidad-edify") && !myPerson ? (
        <h4 className={styles.miPerfil_header_goBack} onClick={handleGoBack}>Volver al listado </h4>
      ) : null}
      <div className={styles.miPerfil_container}>
        {/* <section className={styles.miPerfil_content}>
          <UserInfo
            fromProfile
            isEditing={isEditing}
            userData={!myPerson && userId ? profileVisualizer : userData}
            myPerson={myPerson}
          />
          <div
            key={`datos1-${userId}`}
            className={`${styles.miPerfil_contentContainer} ${isEditing ? styles.isEditing : ""
              }`}
          >
            <div
              key={`datos-${userId}`}
              className={styles.miPerfil_reputationContainer}
            >
              <Reputacion userId={userId} key={userId} />
            </div>
            <div className={styles.contactContainer}>
              <div className={styles.miPerfil_logosContainer}>
                <p className={styles.miPerfil_logosContainer_title}><b>Contacto</b></p>
                <div className={styles.miPerfil_logosContainer_mail}>
                  <img
                    key={`mail-${userId}`}
                    src={mail}
                    onClick={onMail}
                    alt={"mail"}
                    title={`Enviar correo a ${username}`}
                  />
                  {phone !== null && phone !== "" && phone !== undefined && (
                    <div className={styles.miPerfil_logosContainer}>
                      <div className={styles.miPerfil_logosContainer_wsp} >
                        <a target="blank" href={url} className={styles.miPerfil_logosContainer_wsp_a}>
                          <WhatsAppIcon width={15} height={15} />
                        </a>
                      </div>
                    </div>)}
                  {url_site_web !== null && url_site_web !== "" && url_site_web !== undefined && url_site_web !== "No disponible" && (
                    <div className={styles.miPerfil_webSiteContainer}>
                      <a href={fullUrl} className={styles.miPerfil_webSiteContainer_a} target="_blank" rel="noopener noreferrer" title={`Visitar el sitio web de ${formattedWebSite}`}>
                        <WebIcon width={15} height={15} />
                      </a>
                    </div>)}
                </div>
              </div>
              <div />
            </div>
            {hasSocialNetworks !== null && hasSocialNetworks !== "" && hasSocialNetworks !== undefined && (
              <div className={styles.miPerfil_redesContainer}>
                <p className={styles.miPerfil_redesContainer_title}><b>Redes</b></p>
                <div className={styles.miPerfil_redesContainer_icons}>
                  {linkedin !== null && linkedin !== "" && linkedin !== undefined && (
                    <a target="blank" href={linkedin}>
                      <LinkedinIcon width={15} height={15} />
                    </a>
                  )}
                  {instagram !== null && instagram !== "" && instagram !== undefined && (
                    <a target="blank" href={instagram}>
                      <InstagramIcon width={15} height={15} />
                    </a>
                  )}
                  {facebook !== null && facebook !== "" && facebook !== undefined && (
                    <a target="blank" href={facebook}>
                      <FacebookIcon width={15} height={15} />
                    </a>
                  )}
                  {twitter !== null && twitter !== "" && twitter !== undefined && (
                    <a target="blank" href={twitter}>
                      <TwitterIcon width={15} height={15} />
                    </a>
                  )}
                </div>
              </div>)}

            {myPerson && (
              <div className={styles.miPerfil_footer} onClick={guestAccountCheck(editHandler)}>
                <button className={styles.miPerfil_footer_button} >
                  Editar
                </button>
              </div>)}
          </div>
        </section> */}
        {/* {myPerson && (
          <MiSuscripcion />

        )}
        {myPerson && (
        <div className={styles.plansContainer}>
          <div className={styles.plansContainer_title}>
            <p>PLANES EDIFY</p>
            <p className={styles.plansContainer_subtitle}>{planStatus}</p>
            <p className={styles.plansContainer_highlightedTxt} onClick={() => openSuscriptionModal()}>
              <img src={Star} alt="star" className={styles.plansContainer_star} />
              Conocé los precios y funcionalidades premium</p>
          </div>
        </div>
      )} */}
      </div>
      {isEditing && (
        <ProfileEditModal setIsEditing={setIsEditing} />)}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    newProfileValues: state.profile.newProfileValues,
    file: state.profile.file,
    userData: state.general.userData,
    profileVisualizer: state.general.profileVisualizer,
    previousLocation: state.dashboard.previousLocation,
    isUserPremium: state.general.isUserPremium,
    isCancelledSuscriptionStillActive: state.general.isCancelledSuscriptionStillActive,
  };
};

export default connect(mapStateToProps, {
  openMainModal,
  testPersonaEdit,
  testEmpresaEdit,
  closeMainModal,
  openAction,
  generateVisit,
  openSuscriptionModal,
})(MiPerfil);
